import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=012bf36e"
import script from "./Tutorial.vue?vue&type=script&lang=js"
export * from "./Tutorial.vue?vue&type=script&lang=js"
import style0 from "./Tutorial.vue?vue&type=style&index=0&id=012bf36e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports